import styled from 'styled-components';
import tw from 'twin.macro';

export const StyledTable = styled.table`
    && {
        ${tw`w-full shadow-md border-2 border border-separate`}
        ${({ footer }) => footer ? tw`rounded-t-lg` : tw`rounded-lg`}
        &, td, tr {
            ${({ error }) => error && tw`border-error`}
        }

        tbody {
            tr {
                ${({ isClickable }) => isClickable && tw`cursor-pointer hover:bg-card`}
            }
        }

        border-spacing: 0px;

        thead {
            ${tw`table-header-group border-collapse`}
            border-color: inherit;
        }
        th {
            ${tw`text-left bg-secondary-light`}
        }
        th, td {
            ${tw`px-3 py-2`}
        }
        th:first-child {
            ${tw`rounded-tl-lg`}
        }
        th:last-child {
            ${tw`rounded-tr-lg`}
        }
        tr:first-child {
            td:first-child {
                ${({ header }) => !header && tw`rounded-tl-lg`}
            }
            td:last-child {
                ${({ header }) => !header && tw`rounded-tr-lg`}
            }
        }
        tr:last-child {
            td:first-child {
                ${({ footer }) => !footer && tw`rounded-bl-lg`}
            }
            td:last-child {
                ${({ footer }) => !footer && tw`rounded-br-lg`}
            }
        }
    }
`;

export const StyledRow = styled.tr`
  ${({isDragging}) => isDragging && tw`bg-white border rounded-lg`}

  text-align: ${props => props.align};

  ${tw`table-row`}
  td {
    ${({isDragging}) => !isDragging && tw`border-t`}
  }

  &:first-child td {
    ${tw`border-t-0`}
  }

  &:nth-child(even) {
    ${({error}) => error && tw`bg-error-lighter`}
  }

  &:nth-child(odd) {
    ${({error}) => error
            ? tw`bg-error-light`
            : tw`bg-card-secondary`}
  }

  &:only-child {
    ${tw`bg-paper`}
  }
`;

export const StyledHeader = styled.th`
    ${({ isClickable }) => isClickable && tw`cursor-pointer hover:bg-card`}
`;

export const StyledCell = styled.td`
    text-align: ${props => props.align};
    width: lg:w-${props => props.width ? props.width : 'auto'};
    &&.drag {
        width: 0.3rem;
        ${tw`py-0 pl-1 pr-0 text-color-light`}
    }
`;
